<template>
    <v-card class="mx-auto" color="#003580e3" dark max-width="400">
        <v-card-title>
            <span class="title font-weight-regular">Booking</span>
            <span class="title info--text font-weight-regular">.com</span>
        </v-card-title>

        <v-card-text class="headline font-weight-bold font-italic">
            "{{text}}"
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-list-tile>
                <v-list-tile-avatar color="grey darken-3">
                    <v-img class="elevation-6"
                        src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light">
                    </v-img>
                </v-list-tile-avatar>

                <v-list-tile-content>
                    <v-list-tile-title>{{name}}</v-list-tile-title>
                </v-list-tile-content>
            </v-list-tile>
        </v-card-actions>
    </v-card>
</template>

<script>
  export default {
      props: {
          text: {},
          name: {}
      },
      data: () => ({
          //
      })
  }
</script>